import React, { useState } from 'react';
import { Mail, Clock, Check, Copy } from 'lucide-react';
import { useI18n } from '../../context/I18nContext';
import { Button } from '../ui/Button';

export interface ContactBlockProps {
  appName?: string;
  supportEmail?: string;
}

export const ContactBlock: React.FC<ContactBlockProps> = ({
  appName,
  supportEmail = 'contact@kapitalletter.com',
}) => {
  const { t } = useI18n();
  const [copied, setCopied] = useState(false);

  const handleCopyEmail = () => {
    navigator.clipboard.writeText(supportEmail);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const emailSubject = appName
    ? encodeURIComponent(`[${appName} Support Inquiry]`)
    : encodeURIComponent('[Kapitalletter Support Inquiry]');

  return (
    <div className="bg-white border border-slate-200/90 rounded-2xl p-6 sm:p-8 shadow-xs">
      {/* Top Direct Contact Section */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="space-y-1">
          <h3 className="text-lg font-bold text-slate-900 tracking-tight flex items-center gap-2">
            <Mail className="w-5 h-5 text-primary-600" />
            <span>{t.support.directContactTitle}</span>
          </h3>
          <p className="text-sm text-slate-600 max-w-xl">
            {t.support.directContactDesc}
          </p>
          <div className="flex items-center gap-2 text-xs text-slate-500 pt-1 font-medium">
            <Clock className="w-3.5 h-3.5 text-slate-400" />
            <span>{t.support.responseTimeText}</span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex items-center gap-2.5 w-full sm:w-auto shrink-0">
          <a
            href={`mailto:${supportEmail}?subject=${emailSubject}`}
            className="w-full sm:w-auto"
          >
            <Button variant="primary" size="md" fullWidth>
              이메일로 문의하기
            </Button>
          </a>
          <button
            type="button"
            onClick={handleCopyEmail}
            className="p-2.5 rounded-lg border border-slate-200 hover:bg-slate-50 text-slate-600 hover:text-slate-900 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500"
            title="이메일 주소 복사"
            aria-label="이메일 주소 복사"
          >
            {copied ? <Check className="w-4 h-4 text-emerald-600" /> : <Copy className="w-4 h-4" />}
          </button>
        </div>
      </div>
    </div>
  );
};
